import autonumeric from "https://ga.jspm.io/npm:autonumeric@4.10.5/dist/autoNumeric.min.js"
window.autonumeric = autonumeric

// format money
window.formatMoney = function(price, currency) {
  return autonumeric.format(price, { currencySymbol: currency || '' })
}
